module.exports = __webpack_public_path__ + "img/share-btn.a74aa254.svg";